import { Extent } from "ol/extent";

export interface ExtentConstants {
  [key: string]: Extent;
}

export const BOUNDS: ExtentConstants = {
  /**
   * Constant: OE
   * {Array} left, bottom, right, top values of unbuffered bounding box from Austria
   */
  // OE: [977650, 5838030, 1913530, 6281290],
  OE: [1060000, 5838030, 1913530, 6281290],
  /**
   * Constant: V
   * {Array} left, bottom, right, top values of unbuffered bounding box from Vorarlberg
   */
  V: [1060000, 5913400, 1140000, 6042000], // 1064507, 5913401, 1138054, 6041952
  /**
   * Constant: T
   * {Array} left, bottom, right, top values of unbuffered bounding box from Tyrol
   */
  T: [1126210, 5878320, 1442620, 6064950],
  /**
   * Constant: S
   * {Array} left, bottom, right, top values of unbuffered bounding box from Salzburg
   */
  S: [1345178, 5931931, 1559320, 6113495], // 1345178, 5931931, 1559320, 6113495
  /**
   * Constant: K
   * {Array} left, bottom, right, top values of unbuffered bounding box from Carinthia
   */
  K: [1409967, 5840973, 1678741, 5963000], // 1409967, 5840973, 1678741, 5962000
  /**
   * Constant: OOE
   * {Array} left, bottom, right, top values of unbuffered bounding box from Upper Austria
   */
  OOE: [1420042, 6017540, 1670734, 6235000], // 1420042, 6017540, 1670734, 6235000
  /**
   * Constant: ST
   * {Array} left, bottom, right, top values of unbuffered bounding box from Styria
   */
  ST: [1509491, 5880000, 1803336, 6076000], // 1509491, 5882213, 1803336, 6075257
  /**
   * Constant: NOE
   * {Array} left, bottom, right, top values of unbuffered bounding box from Lower Austria
   */
  NOE: [1607416, 6012000, 1906000, 6279000], // 1607416, 6016164, 1906981, 6270037
  /**
   * Constant: B
   * {Array} left, bottom, right, top values of unbuffered bounding box from Burgenland
   */
  B: [1779799, 5914546, 1911219, 6126068], // 1779799, 5914546, 1911219, 6126068
  /**
   * Constant: W
   * {Array} left, bottom, right, top values of unbuffered bounding box from Vienna
   */
  W: [1801098, 6126000, 1846000, 6161000] // 1801098, 6127304, 1846605, 6159886
};
